<template>
  <article class="flex items-center justify-between bg-gray-800 p-2">
    <p class="mb-0 mr-2 text-xs font-medium text-white">Downhole Data</p>
    <div ref="dropdownContainerRef" class="w-24">
      <VDropdown
        ref="dropdownRef"
        v-model="selectedCommmodity"
        size="xs"
        :options="commodities as Option[]"
        container-classes="right-0 w-40 mt-1 "
        @update:model-value="select"
      >
        <template #current-single="{ item }">{{ item.name }}</template>
        <template #option="{ item }">
          <div class="py-1 px-2">
            <span class="py-1 px-2 text-sm">{{ item.name }}</span>
          </div>
        </template>
      </VDropdown>
    </div>
  </article>
</template>

<script lang="ts" setup>
import type { PropType, DeepReadonly } from 'vue'
import { ref, watch } from 'vue'
import type { Option } from '~/components/VDropdown.vue'

const props = defineProps({
  commodities: {
    type: Array as PropType<DeepReadonly<Option[]>>,
    required: true,
  },
  selectedCommodity: {
    type: Object as PropType<Option>,
    required: true,
  },
})

const emit = defineEmits(['select'])

const selectedCommmodity = ref<Option>({ id: '', name: '' })

watch(
  () => props.commodities,
  () => {
    selectedCommmodity.value = props.selectedCommodity
  },
  { immediate: true },
)

function select(commodity: Option) {
  emit('select', commodity)
  selectedCommmodity.value = commodity
}
</script>
